// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeEntryListForMemberBody = {
  poolId: string;
  targetUserId: string;
  cursor?: string | null;
  limit?: number | null;
};

export type typeEntryListForMemberOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    items: {
      entryId: string;
      contestId: string;
      label: string;
      ownerUserId: string;
      status: "in" | "eliminated" | "revived";
      livesRemaining: number;
      livesTotal: number;
      skipsRemaining?: number | null;
      usedTeamIds: { teamId: string; lockedUntil?: string | null }[];
      pointsTotal: number;
      medalsThisContest: number;
      eliminatedAtRoundId?: string | null;
      revivesUsedThisContest: number;
      revivesUsedThisSeason: number;
    }[];
    total: number;
    nextCursor?: string | null;
  };
};

export type typeEntryListForMemberOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEntryListForMemberOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEntryListForMemberOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaEntryListForMemberBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    targetUserId: { type: "string", maxLength: 3000, minLength: 1 },
    cursor: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    limit: { oneOf: [{ type: "integer" }, { enum: [null] }] },
  },
  required: ["poolId", "targetUserId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createEntryListForMember(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaEntryListForMemberBody);
  }

  return async function postEntryListForMember(
    payload: typeEntryListForMemberBody,
  ): Promise<
    typeEntryListForMemberOutput200 | typeEntryListForMemberOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postEntryListForMember" failed before calling the network. #a3649d95fc65`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#a3649d95fc65" },
        },
        data: null,
      } as typeEntryListForMemberOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/entry/list-for-member`,
      httpMethod: "POST",
      options,
    })) as typeEntryListForMemberOutput200 | typeEntryListForMemberOutput400;
  };
}
